<template>
	<div class="main-content pass-content">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm">
      <el-form-item label="旧密码" prop="oldPass">
        <el-input type="password"  v-model="ruleForm.oldPass" autofocus show-password clearable></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPass">
        <el-input type="password" v-model="ruleForm.newPass" show-password clearable></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPass">
        <el-input type="password" v-model="ruleForm.confirmPass" show-password clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" :disabled="subDis">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
	import ApiService from "../service/ApiService";
	import pub from "../service/public";
  export default {
		name: "ChangePassword",
    data() {
      const validateOldPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入旧密码'));
        }
        callback();
      };
      const validateNewPass = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请输入新密码'));
        } else {
          if (this.ruleForm.confirmPass != '') {
            this.$refs.ruleForm.validateField('confirmPass');
          }
          callback();
        }
      };
      const validateConfirmPass = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请再次输入密码'));
        } else if (value != this.ruleForm.newPass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          confirmPass: '',
          newPass: '',
          oldPass: ''
        },
        rules: {
          newPass: [
            { validator: validateNewPass, trigger: 'change' }
          ],
          confirmPass: [
            { validator: validateConfirmPass, trigger: 'change' }
          ],
          oldPass: [
            { validator: validateOldPass, trigger: 'change' }
          ]
        },
        subDis:false,
      };
    },
    methods: {
      submitForm(formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.initData();
          } else {
            return false;
          }
        });
      },
      initData(){
        let that          = this;
        that.subDis = true;
        let requestParams = {
          page: {
            number: 0,
            Limit: 1
          },
          keyWord: [],
          parms: {
            oldPwd:that.ruleForm.oldPass,
            newPwd:that.ruleForm.newPass
          }
        };
        ApiService.getSetPwd(requestParams).then(function (returnDa) {
          that.subDis = false;
          if(returnDa.code == 0){
            that.$cookies.set(pub.token.token_key, '');//token authorization  post传值需要的
            that.$cookies.set(pub.token.refresh_key, '');//用来刷新authorization
            localStorage.removeItem('UL_WF_UsrInfo');
            that.$cookies.set('save_pwd_wf',that.ruleForm.newPass);
            pub.tip('修改成功，请重新登录！','success');
            setTimeout(function(){
              that.$router.push('/login');
            },1000)
          } else if (returnDa.code == 204) {
            pub.refresh(that.initData);
          } else {
            pub.analysisReturnCode(returnDa);
          }
        })
        .catch(function(error){
          that.subDis = false;
          console.log('修改密码错误信息：'+error)
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    }
	}
</script>

<style scoped lang="scss">
.pass-content{
  width: 900px;
  min-height: 400px;
  height: auto;
  margin: 30px auto;
  overflow: hidden;
  .ruleForm{
    width: 360px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Changepwd.vue